import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService } from "primeng/api";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-config",
  templateUrl: "./config.component.html",
  styleUrls: ["./config.component.scss"],
  providers: [MessageService]
})

export class ConfigComponent implements OnInit {
  configForm: FormGroup;
  selectedColor: string ;
  tableHeaders = [
    { header: "Name", field: "name" ,label: "label"},
    { header: "Property", field: "property",label: "value" }
  ]
  configData: any = []
  tableData: any;
  emptyRows = [
    { name: 'Global Color', property: '' },
    { name: 'Global Image', property: '' },
    { name: '810 Submit', property: '' },
    { name: '855 Submit', property: '' },
    { name: '856 Submit', property: '' },
    { name: '997 Submit', property: '' },
    { name: 'BPLink API', property: '' },
    { name: 'WebForms Tutorial Link', property: '' },
    { name: 'MSCVP Tutorial Link', property: '' },
    { name: "SMTP Host Name", property: '' },
    { name: "SMTP Port", property: '' },
    { name: "SMTP From MailId", property: '' },    
    // { name: "SMTP From Password", property: '' },
    { name: "B2B Reprocess Url", property: '' },
    { name: "B2B Reprocess SfgUrl ", property: '' },
    { name: "S3 Bucket Name", property: '' },
    { name: "S3 Bucket Region", property: '' },
    { name: 'Partner Name', property: '' },
  ];

  loader:boolean;

  constructor(private fb: FormBuilder, public localstorage: LocalStorageService, private session:SessionStorageService,
    private http: HttpClient, private messageService: MessageService) {

  }

  ngOnInit() {
    this.getConfig()
  }


  submit() {
     // https://www.kohler-ups.co.uk/wp-content/uploads/2024/09/rehlko_logo_horiz_midnight_blue_RGB.png
     // https://www.kohler-ups.co.uk/wp-content/uploads/2024/09/rehlko_logo_horiz_midnight_blue_RGB-2048x860.png
     // https://companieslogo.com/img/orig/COLD_BIG-936563b9.png?t=1720244491
     // //console.log(this.configData, "dataaaaaaaa");
     const transformedData = this.configData.map((item) => ({
       [item.name]: item.property,
     }));
     //console.log('Transformed Data:', transformedData);
     const mappedData = transformedData.reduce((acc, item) => {
       const key = Object.keys(item)[0];
       acc[key] = item[key];
       return acc;
     }, {});
     const req = {
       id: this.tableData.id,
       globalImg: mappedData["Global Image"] || "",
       globalColor: this.selectedColor|| "",
       submit_810: mappedData["810 Submit"] || "",
       submit_855: mappedData["855 Submit"] || "",
       submit_856: mappedData["856 Submit"] || "",
       submit_997: mappedData["997 Submit"] || "",
       recieve_997: mappedData["997 Receive"] || "",
       environment: "dev1",
       s3BucketAccessKey: "access_key1",
       s3BucketSecretKey: "secret_key1",
       bpidLink:  mappedData["BPLink API"] || "",
       createdBy: this.session.retrieve("UserDetails").loginId,
       modifiedBy: this.session.retrieve("UserDetails").loginId,
       webFormsTutorialLink : mappedData["WebForms Tutorial Link"] || "",
       mscvpTutorialLink : mappedData["MSCVP Tutorial Link"] || "",
       smtpHostName : mappedData["SMTP Host Name"] || "",
       smtpFromMailId : mappedData["SMTP From MailId"] || "",
       smtpPort : mappedData["SMTP Port"] || "",
      //  smtpFromidPwd : mappedData["SMTP From Password"] || "",
       b2bReprocessUrl : mappedData["B2B Reprocess Url"] || "",
       b2bReprocessSfgUrl : mappedData["B2B Reprocess SfgUrl"] || "",
       s3BbucketName : mappedData["S3 Bucket Name"] || "",
       s3BbucketRegion : mappedData["S3 Bucket Region"] || "",
       footer : mappedData["Partner Name"] || "",
     };
     //console.log(req,"========rewq");
     
     let headers = new HttpHeaders();
     headers = headers.append(
       "authorization",
       this.localstorage.retrieve("token")
     );
     this.http
     .put(environment.apiUrl + "/updateConfigurations", req, {
         headers: headers,
         responseType: "text",
       })
       .subscribe((data: any) => {
         //console.log(data, "dataaa");
         if (data === 'Data updated Successfully') {
           this.messageService.add({
             severity: "success",
             summary: "Success",
             detail: "Configurations Updated Successfully",
           });
         }
         else {
           this.messageService.add({
             severity: "error",
             summary: "Error",
             detail: "Update Failed",
           });
         }
 
       })
   }
 

  editRow(row: any) {
    row.isEditing = true;
  }

  getConfig() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    this.loader = true;
    this.http
      .get(environment.apiUrl + "/getConfigurations", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        //console.log(data, "config dataa===========");
        if (data && Object.keys(data).length > 0) {
        this.tableData = JSON.parse(data)
        //console.log(this.tableData, "tableData");
        this.selectedColor = this.tableData.globalColor;
        this.configData =
          [
            { name: "Global Color", property: this.tableData.globalColor },
            { name: "Global Image", property: this.tableData.globalImg },
            { name: "810 Submit", property: this.tableData.submit_810 },
            { name: "855 Submit", property: this.tableData.submit_855 },
            { name: "856 Submit", property: this.tableData.submit_856 },
            { name: "997 Submit", property: this.tableData.submit_997 },
            { name: "BPLink API", property: this.tableData.bpidLink },
            { name: "WebForms Tutorial Link", property: this.tableData.webFormsTutorialLink },
            { name: "MSCVP Tutorial Link", property: this.tableData.mscvpTutorialLink },
            { name: "SMTP Host Name", property: this.tableData.smtpHostName },
            { name: "SMTP Port", property: this.tableData.smtpPort },
            { name: "SMTP From MailId", property: this.tableData.smtpFromMailId },
            // { name: "SMTP From Password", property: this.tableData.smtpFromidPwd }, 
            { name: "B2B Reprocess Url", property: this.tableData.b2bReprocessUrl },
            { name: "B2B Reprocess SfgUrl", property: this.tableData.b2bReprocessSfgUrl },
            { name: "S3 Bucket Name", property: this.tableData.s3BbucketName }, 
            { name: "S3 Bucket Region", property: this.tableData.s3BbucketRegion }, 
            { name: "Partner Name", property: this.tableData.footer },
          ]
          this.loader = false;
        } else {
          this.configData = this.emptyRows;
        // //console.log(this.configData, "config data");
        this.session.store('backend_config', this.tableData)
        this.loader = false;
        }
      })
  }
}
